import {
  ApolloClient,
  InMemoryCache,
  DefaultOptions,
  HttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = new HttpLink({ uri: process.env.REACT_APP_BACKEND_URL });

const authLink = setContext(async (_, { headers }) => {
  // TODO: Add any auth headers here
  return {
    headers: {
      ...headers,
    },
  }
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
  },
  query: {
    fetchPolicy: 'network-only',
  },
};

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions,
});

export default client;
